import { Box, ColorOptions, Image, Spacer, Text } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/core'
import { footerStrings, staticStrings } from '../../static/staticStrings'
import { colors } from '../../util/colors'
import useFontSize from '../../util/useFontSize'

interface Props {
  isTab: boolean
  isMobile: boolean
}

const JioBizzHomeSection = ({ isMobile }: Props) => {
  const { headerSize, textSize } = useFontSize()
  const rightArrow = require('../../assets/images/arrow-right-blue.png')
  const jiobizzapp = require('../../assets/images/jiobizzapp.png')
  const { navigate } = useNavigation()
  const onKnowmorePress = () => {
    navigate('jio-pay-business')
  }

  return (
    <Box flexDirection={isMobile ? 'column-reverse' : 'row'} justify={'space-between'} pt={isMobile ? 48 : 120}>
      <Box f={isMobile ? undefined : 1} justify={'center'} mt={isMobile ? 24 : undefined}>
        <Text
          title={footerStrings.jioPayBuzApp}
          fontFamily={'jiotype-black'}
          fontSize={headerSize}
          color={'BLACK_21'}
        />
        <Spacer size={isMobile ? 16 : 32} />
        <Text
          title={staticStrings.jiobizzLabel}
          fontFamily={'jiotype-medium'}
          fontSize={textSize}
          lineHeight={isMobile ? 20 : 28}
          color={'BLACK_21'}
          opacity={0.9}
        />
        <Spacer size={isMobile ? 32 : 40} />
        <Box flexDirection={'row'} align={'center'}>
          <Box>
            <Image
              source={require('../../assets/images/google-play.png')}
              resizeMode={'contain'}
              width={isMobile ? 132 : 164}
              height={isMobile ? 40 : 48}
            />
          </Box>
          <Spacer size={20} direction="horizontal" />
          <Box flexDirection={'row'} align={'center'} onPress={onKnowmorePress} underlayColor={'TRANSPARENT'}>
            <Text
              title={'Know More'}
              color={colors.HIGHLIGHT as ColorOptions}
              fontFamily={'jiotype-medium'}
              fontSize={textSize}
            />
            <Box pt={2} pl={8}>
              <Image source={rightArrow} height={24} width={24} resizeMode="contain" />
            </Box>
          </Box>
        </Box>
      </Box>
      <Box f={isMobile ? undefined : 1} align={'flex-end'}>
        <Image source={jiobizzapp} height={isMobile ? 258 : 450} width={isMobile ? 300 : 450} resizeMode="cover" />
      </Box>
    </Box>
  )
}

export default JioBizzHomeSection
